import mutations from './mutations.js';
import actions from './actions.js';
import getters from './getters.js';

export default {
  state() {
    return {
      user:  null,
      token: localStorage.getItem("token"),
      theme: localStorage.getItem("portal_theme") || "dark",
      isMaster: localStorage.getItem("is_master") === "1",
    };
  },
  mutations,
  actions,
  getters,
  namespaced: false
};
